import React from 'react';
import "../styles/Privacy.css";

export default function SystemRegulations() {
    return (
        <div className="container">
            <h1 className="title">Regulamin Systemu Arrio – PSDiA</h1>
            <p className="meta">Ostatnia aktualizacja: 1 grudnia 2025 r.</p>

            <Section title="§ 1. Postanowienia ogólne">
                <ol>
                    <li>
                        Niniejszy regulamin (dalej: „Regulamin”) określa zasady korzystania z systemu
                        „System Arrio – PSDiA” (dalej: „System”) prowadzonego przez Fundację Polska
                        Szkoła Dendrologii i Arborystyki (dalej: „Fundacja” lub „Usługodawca”).
                    </li>
                    <li>
                        Regulamin stanowi regulamin świadczenia usług drogą elektroniczną w rozumieniu
                        przepisów prawa polskiego.
                    </li>
                    <li>
                        Korzystanie z Systemu jest możliwe po uprzednim zapoznaniu się z Regulaminem
                        oraz Polityką prywatności i stanowi akceptację ich postanowień.
                    </li>
                    <li>
                        System jest przeznaczony wyłącznie dla osób pełnoletnich.
                    </li>
                </ol>
            </Section>

            <Section title="§ 2. Definicje">
                <p>Na potrzeby Regulaminu przyjmuje się następujące znaczenie użytych poniżej pojęć:</p>
                <ol>
                    <li>
                        „System” – system informatyczny „System Arrio – PSDiA” udostępniany przez
                        Fundację, służący w szczególności organizacji i obsłudze zajęć dydaktycznych,
                        kursów i komunikacji związanej z działalnością Fundacji;
                    </li>
                    <li>
                        „Fundacja” / „Usługodawca” – Fundacja Polska Szkoła Dendrologii i Arborystyki, ul.
                        Cieszyńska 71, 43-300 Bielsko-Biała, KRS: 0000856513, NIP: 5472220438;
                    </li>
                    <li>
                        „Użytkownik” – osoba fizyczna, która ukończyła 18 lat, posiadająca konto w Systemie
                        lub korzystająca z Systemu w inny sposób zgodny z Regulaminem;
                    </li>
                    <li>
                        „Konto” – indywidualny panel administracyjny użytkownika w Systemie, dostępny po
                        zalogowaniu, umożliwiający korzystanie z funkcjonalności Systemu;
                    </li>
                    <li>
                        „Umowa” – umowa o świadczenie usług drogą elektroniczną, zawierana pomiędzy
                        Fundacją a Użytkownikiem poprzez akceptację Regulaminu i korzystanie z Systemu;
                    </li>
                    <li>
                        „Polityka prywatności” – dokument określający zasady przetwarzania danych
                        osobowych Użytkowników, dostępny w Systemie oraz na stronie Fundacji.
                    </li>
                </ol>
            </Section>

            <Section title="§ 3. Rodzaje i zakres usług">
                <ol>
                    <li>
                        Za pośrednictwem Systemu Fundacja umożliwia Użytkownikom w szczególności:
                        <ol>
                            <li>zakładanie i utrzymywanie Konta,</li>
                            <li>dostęp do materiałów dydaktycznych, informacji o kursach i zajęciach,</li>
                            <li>
                                udział w zajęciach i kursach prowadzonych lub organizowanych przez
                                Fundację (w zakresie, w jakim odbywa się to z wykorzystaniem Systemu),
                            </li>
                            <li>
                                komunikację wewnętrzną związaną z organizacją zajęć, kursów oraz innymi
                                działaniami Fundacji,
                            </li>
                            <li>wgląd w informacje dotyczące przebiegu udziału w kursach (np. obecności,zaliczenia).</li>
                        </ol>
                    </li>
                    <li>
                        Fundacja może rozszerzać lub modyfikować zakres funkcjonalności Systemu, przy
                        zachowaniu praw nabytych Użytkowników.
                    </li>
                </ol>
            </Section>

            <Section title="§ 4. Warunki techniczne korzystania z Systemu">
                <ol>
                    <li>
                        Do korzystania z Systemu niezbędne jest spełnienie łącznie następujących warunków:
                        <ol>
                            <li>posiadanie urządzenia z dostępem do sieci Internet,</li>
                            <li>posiadanie aktualnej wersji przeglądarki internetowej,</li>
                            <li>posiadanie aktywnego adresu poczty elektronicznej (adresu e-mail),</li>
                            <li>włączenie w przeglądarce obsługi plików cookie niezbędnych do działania Systemu.</li>
                        </ol>
                    </li>
                    <li>
                        Użytkownik ponosi odpowiedzialność za spełnienie wymagań technicznych po swojej
                        stronie, w szczególności za zapewnienie bezpieczeństwa urządzenia i oprogramowania.
                    </li>
                </ol>
            </Section>

            <Section title="§ 5. Zawarcie i rozwiązanie Umowy">
                <ol>
                    <li>
                        Zawarcie Umowy następuje z chwilą:
                        <ol>
                            <li>rejestracji Konta w Systemie przez Użytkownika oraz akceptacji Regulaminu, albo</li>
                            <li>
                                pierwszego faktycznego skorzystania z funkcjonalności Systemu przez
                                Użytkownika, w przypadkach, gdy nie wymaga się rejestracji Konta.
                            </li>
                        </ol>
                    </li>
                    <li>Umowa zostaje zawarta na czas nieoznaczony.</li>
                    <li>
                        Użytkownik może w każdym czasie rozwiązać Umowę poprzez:
                        <ol>
                            <li>usunięcie Konta, o ile funkcjonalność Systemu to umożliwia, albo</li>
                            <li>
                                złożenie stosownego oświadczenia o rezygnacji z korzystania z Systemu
                                drogą elektroniczną na adres: <strong>sekretariat@szkoladendrologii.pl</strong>.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Fundacja może rozwiązać Umowę z Użytkownikiem, z zachowaniem odpowiedniego
                        terminu lub ze skutkiem natychmiastowym, w szczególności w przypadku:
                        <ol>
                            <li>rażącego naruszenia przez Użytkownika postanowień Regulaminu,</li>
                            <li>
                                korzystania z Systemu w sposób sprzeczny z prawem, dobrymi obyczajami
                                lub zagrażający bezpieczeństwu Systemu lub innych Użytkowników.
                            </li>
                        </ol>
                    </li>
                </ol>
            </Section>

            <Section title="§ 6. Zasady korzystania z Systemu">
                <ol>
                    <li>
                        Użytkownik zobowiązany jest do korzystania z Systemu w sposób zgodny z:
                        <ol>
                            <li>obowiązującymi przepisami prawa,</li>
                            <li>postanowieniami Regulaminu i Polityki prywatności,</li>
                            <li>przyjętymi zwyczajami i zasadami współżycia społecznego.</li>
                        </ol>
                    </li>
                    <li>
                        Użytkownik w szczególności zobowiązany jest do:
                        <ol>
                            <li>podawania danych zgodnych z prawdą i niewprowadzających w błąd,</li>
                            <li>
                                nieudostępniania swojego Konta oraz danych uwierzytelniających (loginu i
                                hasła) osobom trzecim,
                            </li>
                            <li>niepodejmowania działań mogących zakłócić działanie Systemu,</li>
                            <li>
                                nieumieszczania w Systemie treści bezprawnych, w tym naruszających dobra
                                osobiste, prawa własności intelektualnej lub inne prawa osób trzecich.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Użytkownik ponosi pełną odpowiedzialność za treści umieszczane w Systemie za
                        pomocą swojego Konta.
                    </li>
                </ol>
            </Section>

            <Section title="§ 7. Prawa i obowiązki Fundacji">
                <ol>
                    <li>
                        Fundacja dokłada należytej staranności w celu zapewnienia prawidłowego działania
                        Systemu oraz jego stałej dostępności, z zastrzeżeniem możliwych przerw
                        technicznych, o których mowa w § 8.
                    </li>
                    <li>
                        Fundacja ma prawo do:
                        <ol>
                            <li>
                                czasowego ograniczenia lub zawieszenia działania Systemu w związku z
                                koniecznością przeprowadzenia prac konserwacyjnych lub modernizacyjnych,
                            </li>
                            <li>
                                blokady Konta lub ograniczenia zakresu funkcjonalności Konta Użytkownika
                                w przypadku naruszenia przez niego postanowień Regulaminu lub przepisów prawa.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Fundacja nie ponosi odpowiedzialności za:
                        <ol>
                            <li>
                                zakłócenia w funkcjonowaniu Systemu spowodowane siłą wyższą, działaniem
                                osób trzecich lub niespełnieniem przez Użytkownika wymogów technicznych,
                            </li>
                            <li>
                                szkody wynikłe z korzystania z Systemu w sposób sprzeczny z Regulaminem
                                lub przepisami prawa.
                            </li>
                        </ol>
                    </li>
                </ol>
            </Section>

            <Section title="§ 8. Dostępność Systemu i przerwy techniczne">
                <ol>
                    <li>
                        Fundacja zastrzega sobie możliwość czasowego wyłączenia lub ograniczenia
                        dostępności Systemu w związku z koniecznością przeprowadzenia prac
                        technicznych, konserwacyjnych lub modernizacyjnych.
                    </li>
                    <li>
                        O planowanych, dłuższych przerwach technicznych Fundacja, w miarę możliwości,
                        informuje z wyprzedzeniem poprzez komunikat w Systemie lub inną odpowiednią drogą.
                    </li>
                </ol>
            </Section>

            <Section title="§ 9. Dane osobowe">
                <ol>
                    <li>
                        Dane osobowe Użytkowników są przetwarzane zgodnie z RODO oraz innymi
                        obowiązującymi przepisami prawa, na zasadach określonych w Polityce prywatności.
                    </li>
                    <li>
                        Polityka prywatności jest udostępniana Użytkownikom w Systemie oraz na stronie
                        internetowej Fundacji.
                    </li>
                </ol>
            </Section>

            <Section title="§ 10. Reklamacje">
                <ol>
                    <li>
                        Użytkownik ma prawo zgłosić reklamację dotyczącą funkcjonowania Systemu lub
                        świadczenia usług drogą elektroniczną.
                    </li>
                    <li>
                        Reklamację można zgłosić w formie elektronicznej na adres: <strong>sekretariat@szkoladendrologii.pl</strong>.
                    </li>
                    <li>
                        W treści reklamacji zaleca się podanie co najmniej:
                        <ol>
                            <li>danych umożliwiających identyfikację Użytkownika,</li>
                            <li>opisu zgłaszanego problemu,</li>
                            <li>wskazania daty wystąpienia zdarzenia.</li>
                        </ol>
                    </li>
                    <li>
                        Fundacja rozpatruje reklamację w możliwie najkrótszym terminie, co do zasady nie
                        dłuższym niż 30 dni od dnia jej otrzymania, i udziela odpowiedzi za pośrednictwem
                        poczty elektronicznej.
                    </li>
                </ol>
            </Section>

            <Section title="§ 11. Zmiany Regulaminu">
                <ol>
                    <li>
                        Fundacja może dokonywać zmian Regulaminu z ważnych przyczyn, w szczególności:
                        <ol>
                            <li>zmian przepisów prawa mających wpływ na świadczenie usług drogą elektroniczną,</li>
                            <li>zmian funkcjonalności lub sposobu działania Systemu,</li>
                            <li>konieczności doprecyzowania postanowień Regulaminu.</li>
                        </ol>
                    </li>
                    <li>
                        O zmianach Regulaminu Fundacja poinformuje Użytkowników poprzez
                        udostępnienie jednolitego tekstu Regulaminu w Systemie oraz poprzez odpowiedni komunikat.
                    </li>
                    <li>
                        Zmiany Regulaminu wchodzą w życie z dniem wskazanym w treści Regulaminu, nie
                        krótszym niż 14 dni od dnia udostępnienia informacji o zmianach, chyba że przepisy
                        prawa stanowią inaczej.
                    </li>
                    <li>
                        Dalsze korzystanie z Systemu po wejściu w życie zmian Regulaminu oznacza
                        akceptację jego nowej treści.
                    </li>
                </ol>
            </Section>

            <Section title="§ 12. Postanowienia końcowe">
                <ol>
                    <li>
                        W sprawach nieuregulowanych Regulaminem zastosowanie mają przepisy prawa
                        polskiego, w szczególności przepisy Kodeksu cywilnego oraz przepisy dotyczące
                        świadczenia usług drogą elektroniczną.
                    </li>
                    <li>
                        Regulamin wchodzi w życie z dniem opublikowania go w Systemie lub na stronie
                        internetowej Fundacji i obowiązuje do czasu jego zmiany lub uchylenia.
                    </li>
                </ol>
            </Section>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section className="section-block">
            <h2 className="section-title">{title}</h2>
            <div className="section-content">{children}</div>
        </section>
    );
}